// Script to launch Ketch - a plugin for consent management/user privacy/data management
export default function KetchPlugin() {
    return (
        <>
            <script
                async
                id="ketch"
                dangerouslySetInnerHTML={{
                    __html: `
!function(){window.semaphore=window.semaphore||[],window.ketch=function(){window.semaphore.push(arguments)};var e=document.createElement("script");e.type="text/javascript",e.src="https://global.ketchcdn.com/web/v3/config/img_academy/imgacademy_com/boot.js",e.defer=e.async=!0,document.getElementsByTagName("head")[0].appendChild(e)}();
                  `,
                }}
            />
        </>
    );
}
